/*
 * Created by TUTEHUB.
 * Copyright © TUTEHUB. All rights reserved.
 * ------------------------
 * Non-disclosure Terms
 * ------------------------
 * These codes are TUTEHUB's property, as the developer, such as employee, contractor, and intern, working for TUTEHUB cannot disclose, spread, copy, preserve, sell, and do other activities without the consent of TUTEHUB.
 * Technique Support: jobyme88.com
 */

import React from 'react'
import './bottomButton.scss'


export default function BottomButton(props) {
    return (
        <div class="btn-list mt-5 mb-3">
            {
                props.btns.map((btn) => (
                    <button class="common-advisory-btn animation-translation-bt an-active">{btn}</button>
                ))
            }
        </div>
    )
}
